import { TaroElement } from './element'

// for Vue3
export class SVGElement extends TaroElement {}
